import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { CsvService } from '../../services/csv.service';
import { select, Store } from '@ngrx/store';
import { IAppState } from '../../store/app.state';
import { selectBeneficiariosList } from '../../store/selectors/beneficiarios.selectors';
import { IBeneficiario, ICreateBeneficiario, IUpdateBeneficiario, ILoadPadron } from '../../interfaces/beneficiarios.interface';
import { Actions, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { Table } from 'primeng/table';
import { DownloadService } from 'src/app/services/download.service';
import {
  CreateBeneficiario, CreateBeneficiarioSuccess, DeleteBeneficiario, DeleteBeneficiarioSuccess,
  GetBeneficiarios, UpdateBeneficiario, UpdateBeneficiarioSuccess, GetEstudioBeneficiario, LoadPadrones,
  LoadPadronesSuccess,
  GetBeneficiariosSuccess
} from '../../store/actions/beneficiarios.actions';
import { GetProgramas } from 'src/app/store/actions/programas.actions';
import { GetInstituciones } from 'src/app/store/actions/instituciones.actions';
import { selectInstitucionesList } from 'src/app/store/selectors/instituciones.selectors';
import { selectProgramasList } from 'src/app/store/selectors/programas.selectors';
import { IPrograma } from 'src/app/interfaces/programas.insterface';
import { AuthenticationService } from '../../services/authentication.service';
import { selectCentrosList } from 'src/app/store/selectors/centros.selectors';
import { selectFormulariosAsignadosList, selectFormulariosList } from 'src/app/store/selectors/formularios.selectors';
import { CreateFormularioAsignados, CreateFormularioAsignadosSuccess, GetFormularios, GetFormulariosAsignados, GetFormulariosAsignadosSuccess } from 'src/app/store/actions/formularios.actions';
import { GetCentros } from 'src/app/store/actions/centros.actions';
import { ExportExcelService } from 'src/app/services/export-excel.service';

@Component({
  selector: 'app-seguimiento',
  templateUrl: './seguimiento.component.html',
  styleUrls: ['./seguimiento.component.scss']
})
export class SeguimientoComponent implements OnInit, OnDestroy {
  @ViewChild('dt', { static: false }) table: Table;

  beneficiarios = this.store$.pipe(
    select(selectBeneficiariosList),
    map(beneficiarios => beneficiarios.map(beneficiario => {
      this.beneficiariosExcel.push(beneficiario)
      return {
        ...beneficiario
      }
    }))
  );

  formulariosAsignados = this.store$.pipe(
    select(selectFormulariosAsignadosList)
  );

  getSubscription = this.actions$.pipe(
    ofType(GetBeneficiariosSuccess),
  ).subscribe(_ => {
    // this.currentToken = this.authenticationService.currentTokenValue;
  });

  createFormulariosSubscription = this.actions$.pipe(
    ofType(CreateFormularioAsignadosSuccess),
  ).subscribe(_ => {
    this.store$.dispatch(GetFormulariosAsignados({ id: this.beneficiarioID }));
    this.spinner = false;
  });

  padronesSubscription = this.actions$.pipe(
    ofType(LoadPadronesSuccess),
  ).subscribe(_ => {

    this.tempContent.splice(0, 1);

    if (this.tempContent.length !== 0) {
      this.loadPadron();
    } else {
      this.lefTempContent = this.totalTempContent;
      setTimeout(() => {
        this.displayPadron = false;
        this.spinner = false;
      }, 1500);
    }

  });

  instituciones = this.store$.pipe(
    select(selectInstitucionesList),
    map(instituciones => instituciones.map(insitucion => {
      return { label: insitucion.institucion, value: insitucion.institucion }
    }))
  );

  programas = this.store$.pipe(
    select(selectProgramasList),
    map(programas => programas.map(programa => {
      return { label: programa.programa_social, value: programa.programa_social }
    }))
  );

  centros = this.store$.pipe(
    select(selectCentrosList),
    map(centros => centros.map(centro => {
      return { label: centro.nombre, value: centro.nombre }
    }))
  );

  formularios = this.store$.pipe(
    select(selectFormulariosList),
    map(formularios => formularios.map(formulario => {
      return { label: formulario.titulo, value: formulario.form }
    }))
  );

  cols: any[];
  colsPublic: any[];
  colsPadron: any[];
  colsFormularios: any[];

  mode = '';
  beneficiario = '';
  header = '';
  displayForm = false;
  displayFormulario = false;
  displayEstudio = false;
  displayPadron = false;
  formularioAsignado: any;
  formularioAsignadoData: any;
  content: any;
  tempContent = [];
  totalTempContent = 0;
  lefTempContent = 0;
  programa: any = '';
  yearPadron: any = '';
  padronVerify = false;
  currentToken = '';
  beneficiarioID: any;
  spinner = false;
  beneficiariosExcel = [];
  dataForExcel = [];
  temporaryCount: any;

  horarios = [
    { label: 'Por la mañana (antes de las 12pm)', value: 'Por la mañana (antes de las 12pm)' },
    { label: 'Por la tarde (entre 12pm y 5pm)', value: 'Por la tarde (entre 12pm y 5pm)' },
    { label: 'Por la tarde-noche (de 6pm en adelante)', value: 'Por la tarde-noche (de 6pm en adelante)' }
  ];

  meses = [
    { label: 'Enero', value: 'Enero' },
    { label: 'Febrero', value: 'Febrero' },
    { label: 'Marzo', value: 'Marzo' },
    { label: 'Abril', value: 'Abril' },
    { label: 'Mayo', value: 'Mayo' },
    { label: 'Junio', value: 'Junio' },
    { label: 'Julio', value: 'Julio' },
    { label: 'Agosto', value: 'Agosto' },
    { label: 'Septiembre', value: 'Septiembre' },
    { label: 'Octubre', value: 'Octubre' },
    { label: 'Noviembre', value: 'Noviembre' },
    { label: 'Diciembre', value: 'Diciembre' }
  ];

  formBeneficiario: FormGroup;

  downloadItems = [
    { label: 'CSV', command: () => { this.downloadService.exportCSV('beneficiarias', this.table) } },
    { label: 'PDF', command: () => { this.downloadService.exportPdf('beneficiarias', this.table) } },
  ];


  formSubmitSubscription = this.actions$.pipe(
    ofType(UpdateBeneficiarioSuccess, DeleteBeneficiarioSuccess, CreateBeneficiarioSuccess),
    tap(_ => {
      this.store$.dispatch(GetBeneficiarios());
      this.displayForm = false;
      this.displayPadron = false;
    })
  ).subscribe();

  constructor(
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private store$: Store<IAppState>,
    private actions$: Actions,
    public downloadService: DownloadService,
    private csvService: CsvService,
    private authenticationService: AuthenticationService,
    private ete: ExportExcelService
  ) {
    this.currentToken = this.authenticationService.currentTokenValue;

    this.formBeneficiario = this.formBuilder.group({
      _id: new FormControl(''),
      nombre: new FormControl(''),
      apellido_paterno: new FormControl(''),
      apellido_materno: new FormControl(''),
      edad: new FormControl(''),
      sexo: new FormControl(''),
      calle: new FormControl(''),
      numero_exterior: new FormControl(''),
      localidad: new FormControl(''),
      municipio: new FormControl(''),
      telefono: new FormControl(''),
      celular: new FormControl(''),
      correo_contacto: new FormControl(''),
      horario_disponibilidad: new FormControl(''),
      year: new FormControl(''),
      programa: new FormControl(''),
      institucion: new FormControl(''),
      concepto_apoyo: new FormControl(''),
      fecha_apoyo: new FormControl(''),
      monto_apoyo: new FormControl(''),
      tipo_apoyo: new FormControl(''),
      curp: new FormControl(''),
      centro: new FormControl(''),
      mes_inicio: new FormControl(''),
      colonia: new FormControl(''),
      year_nacimeinto: new FormControl(''),
    });
  }

  async ngOnInit() {
    this.cols = [
      { field: 'programa', header: 'Programa Social', exportable: true },
      { field: 'centro', header: 'Centro de Aprendizaje', exportable: true },
      { field: 'nombre', header: 'Nombre', exportable: true },
      { field: 'apellido_paterno', header: 'Apellido Paterno', exportable: true },
      { field: 'apellido_materno', header: 'Apellido Materno', exportable: true },
      { field: 'municipio', header: 'Municipio', exportable: true },
      { field: 'acciones', header: 'Acciones', exportable: false }
    ];

    this.colsPublic = [
      { field: 'programa', header: 'Programa Social', exportable: true },
      { field: 'nombre', header: 'Nombre', exportable: true },
      { field: 'apellido_paterno', header: 'Apellido Paterno', exportable: true },
      { field: 'apellido_materno', header: 'Apellido Materno', exportable: true },
      { field: 'monto_apoyo', header: 'Monto Apoyo', exportable: true },
      { field: 'acciones', header: 'Acciones', exportable: false }
    ];

    this.colsPadron = [
      { field: 'nombre', header: 'Nombre' },
      { field: 'apellido_paterno', header: 'Apellido Paterno' },
      { field: 'apellido_materno', header: 'Apellido Materno' },
      { field: 'municipio', header: 'Municipio' },
      { field: 'programa', header: 'Programa' },
      { field: 'year', header: 'Año del Padron' }
    ];

    this.colsFormularios = [
      { field: 'titulo', header: 'Titulo' },
      { field: 'editURL', header: 'URL Formulario' }
    ];

    this.store$.dispatch(GetBeneficiarios());
    this.store$.dispatch(GetProgramas());
    this.store$.dispatch(GetInstituciones());
    this.store$.dispatch(GetFormularios());
    this.store$.dispatch(GetCentros());
  }

  ngOnDestroy() {
    this.formSubmitSubscription.unsubscribe();
  }

  editarBeneficiario(beneficiario): void {
    this.mode = 'EDITAR'
    this.header = 'Editar Beneficiario';
    this.formBeneficiario.patchValue({
      ...beneficiario
    });
    this.formBeneficiario.enable();

    this.displayForm = true;
  }

  verBeneficiario(beneficiario): void {
    this.mode = 'DETALLE'
    this.header = 'Detalle Beneficiario'
    this.formBeneficiario.patchValue({
      ...beneficiario
    });
    this.formBeneficiario.disable();

    this.displayForm = true;
  }

  agregarBeneficiario() {
    this.mode = 'AGREGAR'
    this.header = 'Agregar Beneficiario'
    this.formBeneficiario.patchValue({
      _id: '',
      nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      edad: '',
      sexo: '',
      calle: '',
      numero_exterior: '',
      localidad: '',
      municipio: '',
      telefono: '',
      celular: '',
      correo_contacto: '',
      horario_disponibilidad: '',
      year: '',
      programa: '',
      institucion: '',
      concepto_apoyo: '',
      fecha_apoyo: '',
      monto_apoyo: '',
      tipo_apoyo: '',
      curp: '',
      centro: '',
      mes_inicio: '',
      colonia: '',
      year_nacimeinto: '',
    })
    this.formBeneficiario.enable();

    this.displayForm = true;
  }

  borrarBeneficiario(beneficiario: IBeneficiario) {
    this.confirmationService.confirm({
      header: 'Borrar Beneficiario',
      message: `¿Seguro que quiere borrar el Beneficiario '${beneficiario.nombre}'?`,
      acceptLabel: 'Aceptar',
      rejectVisible: false,
      accept: async () => {
        this.store$.dispatch(DeleteBeneficiario({ id: beneficiario._id }))
      }
    });
  }

  verFormularios(beneficiario: IBeneficiario) {
    this.beneficiarioID = beneficiario._id;
    this.store$.dispatch(GetFormulariosAsignadosSuccess({ formulariosAsignados: [] }));
    this.store$.dispatch(GetFormulariosAsignados({ id: beneficiario._id }));
    this.header = 'Formularios';
    this.displayFormulario = true;
    this.formularioAsignadoData = {
      form: '', id: beneficiario._id, nombre: beneficiario.nombre || '', paterno: beneficiario.apellido_paterno || '',
      materno: beneficiario.apellido_materno || '', curp: beneficiario.curp || '', centro: beneficiario.centro || '', celular: beneficiario.celular || ''
    };
  }

  asignarFormulario() {
    this.spinner = true;
    const form = { ...this.formularioAsignadoData }
    form.form = this.formularioAsignado;
    this.store$.dispatch(CreateFormularioAsignados({ formulariosAsignados: form }));
  }

  submitForm() {
    const form: IBeneficiario = this.formBeneficiario.getRawValue();

    if (this.mode === 'AGREGAR') {
      const payload: ICreateBeneficiario = {
        ...form,
      }

      this.store$.dispatch(CreateBeneficiario({ beneficiario: payload }));
    } else if (this.mode === 'EDITAR') {
      const payload: IUpdateBeneficiario = {
        ...form,
      }

      this.store$.dispatch(UpdateBeneficiario({ id: form._id, beneficiario: payload }));
    }

    return;
  }

  verEstudio(beneficiario: IBeneficiario) {
    this.mode = 'DETALLE';
    this.beneficiario = beneficiario._id;
    this.displayEstudio = true;
  }

  editarEstudio(beneficiario: IBeneficiario) {
    this.mode = 'EDITAR';
    this.beneficiario = beneficiario._id;
    this.displayEstudio = true;
  }

  verifyPadron() {
    if (this.programa !== '' && this.yearPadron !== '') {
      this.padronVerify = true;
    }
  }

  cargarPadron() {
    this.header = 'Cargar padron de beneficiarios'
    this.displayPadron = true;

    this.totalTempContent = 0;
    this.lefTempContent = 0;
    this.content = null;
  }

  readFile(file: File) {
    const reader = new FileReader();
    reader.onload = async () => {
      const data = await this.csvService.generate(reader.result);
      const rows = data.map(object => {
        return {
          nombre: object.Nombre || '',
          apellido_paterno: object['Primer apellido'] || '',
          apellido_materno: object['Segundo apellido'] || '',
          municipio: object.Municipio || '',
          programa: this.programa || '',
          year: this.yearPadron || '',
          concepto_apoyo: object['Concepto apoyo'] || '',
          fecha_apoyo: object['Fecha apoyo'] || '',
          monto_apoyo: object['Monto apoyo'] || '',
          tipo_apoyo: object['Tipo de apoyo'] || '',
        }
      });

      this.content = rows;
      this.temporaryCount = this.content.length;
      let tempArray;
      const chunk = 200;

      for (let i = 0; i < this.content.length; i += chunk) {
        tempArray = this.content.slice(i, i + chunk);

        this.tempContent.push(tempArray);
      }

      this.totalTempContent = this.tempContent.length;

    };

    reader.readAsText(file);
  }

  fileChanged(e) {
    const file = e.target.files[0];
    this.readFile(file);
  }

  async loadPadron() {
    this.spinner = true;

    const payload: ILoadPadron = {
      beneficiarios: this.tempContent[0],
    };

    this.store$.dispatch(LoadPadrones({ beneficiarios: payload }));
    this.lefTempContent = (this.totalTempContent - this.tempContent.length);

    this.programa = '';
    this.yearPadron = '';
    this.padronVerify = false;
  }

  closeEstudio() {
    this.displayEstudio = false;
  }

  exportToExcel() {
    this.dataForExcel = [];

    const uniqueArray = this.beneficiariosExcel.filter((value, index) => {
      const _value = JSON.stringify(value);
      return index === this.beneficiariosExcel.findIndex(obj => {
        return JSON.stringify(obj) === _value;
      });
    });

    uniqueArray.forEach((row: any) => {
      const insert = { ...row }
      this.dataForExcel.push(Object.values(insert))
    })

    const headers = {
      id: '', Nombre: '', 'Apellido Paterno': '', 'Apellido Materno': '',
      Sexo: '', municipio: '', Telefono: '', Celular: '', 'Correo de Contacto': '', 'Año de inicio en el Programa': '',
      'Programa Social': '', 'Concepto de apoyo': '', 'Fecha de Apoyo': '', 'Monto de Apoyo': '',
      'Tipo de Apoyo': '', CURP: '', 'Centro de Aprendeizaje': '', 'Mes de Inicio en el programa': '', Colonia: '', 'Año de Nacimiento': '',
    }

    const reportData = {
      title: 'Personas Beneficiarias',
      data: this.dataForExcel,
      headers: Object.keys(headers)
    }

    this.ete.exportExcel(reportData, false);
  }
}
